import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const Wrapper = styled.a`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  width: 100%;
  padding: ${Spacing.S8} ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${BorderRadius.R12};
`

export const IconWrapper = styled.div`
  min-width: 96px;
  height: 65px;
  svg {
    width: 100%;
    height: 100%;
  }
`
